var _defs, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnquiryManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 233.49 233.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #0097d8;\n      }\n\n      .cls-3 {\n        stroke: #231f20;\n        stroke-width: 3px;\n      }\n\n      .cls-3, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-3, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-2, .cls-11 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-12 {\n        fill: #f9a07b;\n      }\n\n      .cls-13 {\n        fill: #0a2240;\n      }\n\n      .cls-14 {\n        fill: #225570;\n      }\n\n      .cls-15 {\n        fill: #fb3;\n      }\n\n      .cls-5 {\n        stroke: #f2ae30;\n      }\n\n      .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\n        fill: none;\n      }\n\n      .cls-5, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\n        stroke-linecap: round;\n      }\n\n      .cls-16 {\n        fill: #0b2d50;\n      }\n\n      .cls-6 {\n        stroke: #a2c7eb;\n      }\n\n      .cls-17 {\n        fill: #a2c7eb;\n      }\n\n      .cls-18 {\n        fill: #3c738c;\n      }\n\n      .cls-7 {\n        stroke: #0b2d50;\n      }\n\n      .cls-7, .cls-8, .cls-9 {\n        stroke-width: 2px;\n      }\n\n      .cls-8, .cls-11 {\n        stroke: #cc454e;\n      }\n\n      .cls-19 {\n        fill: #262d40;\n      }\n\n      .cls-9 {\n        stroke: #3a92c9;\n      }\n\n      .cls-20 {\n        fill: #cc454e;\n      }\n\n      .cls-10 {\n        stroke: #6f8bbf;\n      }\n\n      .cls-21 {\n        fill: #3d86e0;\n      }\n\n      .cls-22 {\n        fill: #e06a58;\n      }\n\n      .cls-23 {\n        fill: #f2ae30;\n      }\n\n      .cls-24 {\n        fill: #325f73;\n      }\n\n      .cls-2 {\n        stroke: #0097d8;\n      }\n\n      .cls-25 {\n        fill: #ffc73c;\n      }\n\n      .cls-26 {\n        fill: #fce172;\n      }\n\n      .cls-27 {\n        fill: #e8729b;\n      }\n\n      .cls-28 {\n        fill: #3a92c9;\n      }\n\n      .cls-29 {\n        fill: #56c4f9;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 116.74,
    cy: 116.74,
    r: 115.24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M194.04,119.53v-8.41h-3.19c-.38-1.47-.97-2.86-1.71-4.13l2.25-2.26-5.95-5.95-2.26,2.25c-1.28-.75-2.66-1.33-4.13-1.71v-3.19h-8.41v3.19c-1.47,.38-2.86,.97-4.13,1.71l-2.26-2.25-5.95,5.95,2.25,2.26c-.75,1.28-1.33,2.66-1.71,4.13h-3.19v8.41h3.19c.39,1.47,.97,2.86,1.71,4.13l-2.25,2.26,5.95,5.95,2.26-2.25c1.28,.75,2.66,1.33,4.13,1.71v3.19h8.41v-3.19c1.47-.39,2.86-.97,4.13-1.71l2.26,2.25,5.95-5.95-2.25-2.26c.75-1.28,1.33-2.66,1.71-4.13h3.19Zm-19.19,3.08c-4.02,0-7.29-3.26-7.29-7.29s3.26-7.28,7.29-7.28,7.28,3.26,7.28,7.28-3.26,7.29-7.28,7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M168.63,140.6l-1.6-4.17-1.58,.61c-.47-.66-1.02-1.23-1.64-1.72l.69-1.55-4.08-1.82-.69,1.55c-.78-.13-1.57-.15-2.38-.06l-.61-1.58-4.17,1.6,.61,1.58c-.66,.47-1.23,1.02-1.72,1.64l-1.55-.69-1.82,4.08,1.55,.69c-.13,.78-.15,1.57-.06,2.38l-1.58,.61,1.6,4.17,1.58-.61c.47,.66,1.02,1.23,1.64,1.72l-.69,1.55,4.08,1.82,.69-1.55c.78,.13,1.57,.15,2.38,.06l.61,1.58,4.17-1.6-.61-1.58c.66-.47,1.23-1.02,1.72-1.64l1.55,.69,1.82-4.08-1.55-.69c.13-.78,.15-1.57,.06-2.38l1.58-.61Zm-8.93,5.18c-2,.77-4.23-.23-5-2.23-.76-1.99,.23-4.23,2.23-5,1.99-.76,4.23,.23,5,2.23,.77,2-.23,4.23-2.23,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M154.97,125.97l-1.08-2.82-1.07,.41c-.32-.44-.69-.83-1.11-1.16l.47-1.05-2.76-1.23-.47,1.05c-.52-.09-1.06-.1-1.61-.04l-.41-1.07-2.82,1.08,.41,1.07c-.44,.32-.83,.69-1.16,1.11l-1.05-.47-1.23,2.76,1.05,.47c-.09,.52-.1,1.06-.04,1.61l-1.07,.41,1.08,2.82,1.07-.41c.32,.44,.69,.83,1.11,1.16l-.47,1.05,2.76,1.23,.47-1.05c.52,.09,1.06,.1,1.61,.04l.41,1.07,2.82-1.08-.41-1.07c.44-.32,.83-.69,1.16-1.11l1.05,.47,1.23-2.76-1.05-.47c.09-.52,.1-1.06,.04-1.61l1.07-.41Zm-6.03,3.5c-1.35,.52-2.86-.16-3.38-1.51-.52-1.35,.16-2.86,1.51-3.38,1.35-.52,2.86,.16,3.38,1.5,.52,1.35-.16,2.86-1.5,3.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.99,76.64c0,4.23-1.97,7.99-5.05,10.43-2.26,1.8-5.12,2.86-8.24,2.86s-5.97-1.07-8.24-2.86c-3.08-2.43-5.05-6.2-5.05-10.43,0-7.34,5.95-13.29,13.29-13.29s13.29,5.95,13.29,13.29Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 140.7,
    cy: 72.27,
    r: 4.35,
    transform: "translate(-7.79 17.78) rotate(-7.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M148.94,85.39c-2.26,1.8-5.12,2.86-8.24,2.86s-5.97-1.07-8.24-2.86c.85-3.74,1.63-6.97,2.45-7.78,1.15-1.15,4.2-1.82,5.79-1.82s4.78,.81,5.37,1.4c1.2,1.2,2.24,4.52,2.87,8.2Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.61,109.39v-6.56c0-1.79,1.45-3.24,3.24-3.24h20.67c1.79,0,3.24,1.45,3.24,3.24v6.56c0,1.79-1.45,3.24-3.24,3.24h-20.67c-1.79,0-3.25-1.45-3.25-3.24Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "130.34 109.05 120.34 118.79 136.55 110.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.12,102.67v-.03c0-.27,.22-.48,.48-.48h10.22c.27,0,.48,.22,.48,.48v.03c0,.27-.22,.48-.48,.48h-10.22c-.27,0-.48-.22-.48-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M135.76,102.67v-.03c0-.27,.22-.48,.48-.48h8.92c.27,0,.48,.22,.48,.48v.03c0,.27-.22,.48-.48,.48h-8.92c-.27,0-.48-.22-.48-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.87,104.87v-.03c0-.27,.22-.48,.48-.48h12.81c.27,0,.48,.22,.48,.48v.03c0,.27-.22,.48-.48,.48h-12.81c-.27,0-.48-.22-.48-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.12,104.87v-.03c0-.27,.22-.48,.48-.48h5.72c.27,0,.48,.22,.48,.48v.03c0,.27-.22,.48-.48,.48h-5.72c-.27,0-.48-.22-.48-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M133.65,107.06v-.03c0-.27,.22-.48,.48-.48h11.03c.27,0,.48,.22,.48,.48v.03c0,.27-.22,.48-.48,.48h-11.03c-.27,0-.48-.22-.48-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.12,107.06v-.03c0-.27,.22-.48,.48-.48h7.62c.27,0,.48,.22,.48,.48v.03c0,.27-.22,.48-.48,.48h-7.62c-.27,0-.48-.22-.48-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.12,109.26v-.03c0-.27,.22-.48,.48-.48h2.83c.27,0,.48,.22,.48,.48v.03c0,.27-.22,.48-.48,.48h-2.83c-.27,0-.48-.22-.48-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128.91,109.26v-.03c0-.27,.22-.48,.48-.48h15.77c.27,0,.48,.22,.48,.48v.03c0,.27-.22,.48-.48,.48h-15.77c-.27,0-.48-.22-.48-.48Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 59,
    cy: 94.71,
    r: 12.78,
    transform: "translate(-51.76 108.25) rotate(-65.05)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 55.98,
    cy: 100.99,
    r: 3.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "54.36 102.1 54.21 100.13 55.84 99.02 57.61 99.88 57.76 101.84 56.13 102.95 54.36 102.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 62.01,
    cy: 88.44,
    r: 3.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "60.47 89.36 60.58 86.87 62.46 85.22 64.24 86.07 64.13 88.57 62.25 90.22 60.47 89.36"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58.13,99.56l-2.37-1.14,1.75-4.04c.11-.26,.23-.51,.36-.76l2.06-3.89,2.37,1.14-1.69,3.98c-.13,.31-.28,.61-.43,.9l-2.05,3.81Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.88,101.59c.46-.21,7.79,.12,7.79,.12l-5.29-4.85-2.5,4.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 88.71,
    cy: 68.11,
    r: 12.56,
    transform: "translate(-9.02 122.49) rotate(-66.61)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 88.29,
    y: 57.41,
    width: 0.84,
    height: 10.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 83.66,
    y: 66,
    width: 0.84,
    height: 10.69,
    transform: "translate(73.26 181.08) rotate(-124.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M89.87,68.11c0,.64-.52,1.16-1.16,1.16s-1.16-.52-1.16-1.16,.52-1.16,1.16-1.16,1.16,.52,1.16,1.16Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M122.82,153.18c-.74-11.49,4.28-23.37,12.74-30.17,.26,11.54-4.71,23.23-12.74,30.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M134.18,126.1c-3.57,6.65-6.65,13.6-9.21,20.77-3.11,8.71-5.57,17.97-10.9,25.27"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M120.15,160.41c4.28-9.58,12.79-16.82,22.16-18.87-3.99,10.27-12.97,18.1-22.16,18.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M140.01,143.64c-6.4,5.63-12.91,11.11-19.53,16.43"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M117.62,168.75c5.72-8.55,16.28-13.01,25.02-10.57-6.43,8.44-17.01,12.91-25.02,10.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M140.54,158.8c-7.5,4.69-15.6,8.16-23.94,10.24"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M120.71,157.5c1.83-9.63-.91-20.35-7.02-27.45-2.5,9.46-.12,20.54,7.02,27.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M114.32,132.5c1.2,8.95,3.35,17.34,6.67,25.54"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M117.57,165.7c-.78-9.9-5.85-19.19-13.27-24.32,.43,5.24,1.82,10.29,4.03,14.89,2.54,5.28,6.28,8.62,9.24,9.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M105.4,143.38c2.92,8.25,7.12,15.9,12.35,22.52"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M174.85,163.32c4.05-10.53,13.36-19.08,23.63-21.68-4.5,10.39-13.69,18.76-23.63,21.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M196,143.83c-5.87,4.47-11.45,9.4-16.66,14.75-6.32,6.49-12.28,13.73-19.99,18.06"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M169.53,168.67c7.71-6.79,18.2-9.77,27.32-7.77-7.73,7.52-18.88,10.84-27.32,7.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M193.95,161.85c-7.97,2.41-15.97,4.63-24,6.66"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M163.87,175.07c8.56-5.28,19.72-4.94,26.45,.8-9.14,4.89-20.33,4.56-26.45-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M188.22,175.56c-8.55,1.12-17.13,.9-25.36-.64"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M171.22,166.31c5.56-7.83,7.53-18.51,5.04-27.32-6.09,7.4-8.53,18.25-5.04,27.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M175.81,141.43c-2.61,8.47-4.15,16.81-4.57,25.47"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M165.09,172.33c3.37-9.13,2.69-19.48-1.76-27.08-1.77,4.84-2.61,9.91-2.54,14.9,.08,5.73,2.01,10.24,4.3,12.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M163.47,147.48c-.8,8.54-.23,17.07,1.69,25.1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M60.12,144.91c-4.13-12.62-15.64-22.82-29.04-25.72,5.63,10.92,15.85,19.61,29.04,25.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M60.81,146.87c-9.04-5.11-20.37-6.24-30.19-3.01,9.11,4.55,19.9,5.82,30.19,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M63.32,149.6c-9.77-1.35-20,1.05-27.94,6.57,9,3.27,19.79,1.15,27.94-6.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M66.36,155.58c-9.68-.04-19.19,4.56-24.88,12.02,4.31,.86,8.88,.35,12.83-1.44,3.95-1.79,7.26-4.84,12.05-10.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M73.18,165.59c-9.54-1.64-19.71,1.32-26.59,7.73,4.11,1.56,8.7,1.81,12.9,.7,4.2-1.11,7.98-3.57,13.68-8.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M62.88,145.51c-6.3-8.49-8.01-19.93-4.43-29.67,2.73,4.63,5.09,9.52,6.19,14.72,1.1,5.2,.89,10.75-1.76,14.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M66.73,153.7c-1.49-9.02,1.59-18.58,8.11-25.12,.75,9.33-2.11,18.84-8.11,25.12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M34.01,121.45c19.17,12.27,34.17,30.55,42.09,51.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M59.05,120.31c2.33,9.47,3.75,19.14,4.23,28.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M73.41,132.24c-.76,7.64-3.13,15.11-6.9,21.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M34.66,144.08c8.79,1.67,17.73,2.58,26.66,2.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M39.96,155.43c8.11-.59,16.08-2.55,23.45-5.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M44.82,166.25c7.48-3.73,14.96-7.47,22.44-11.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M49.68,172.83c9.77-1.88,12.67-4.13,23.5-7.24"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M111.5,154.95s.85,7.75,1.79,8.37c1.69,1.12,21.26,3.69,21.26,3.69l-.64,5.09s-26.8,2.41-27.94,1.07c-1.98-2.32-5.45-13.53-5.45-13.53l10.98-4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M98.58,135.01l2.17-5.2s5.87,2.76,7.81,6.17c2.07,3.64,4.61,23.01,4.61,23.01,0,0-10.37,2.39-12.28,1.37s-2.31-25.36-2.31-25.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M82.09,110.88c-1.52-.56-3.12-1.04-4.75-.92s-3.28,.98-3.84,2.41c-.39,1.01-.21,2.2-.83,3.11-.59,.87-1.78,1.23-2.88,1.31-1.11,.08-2.22-.07-3.32,.07-3.4,.45-5.82,4.14-4.7,7.16,.44,1.2,1.35,2.35,1.15,3.61-.22,1.34-1.63,2.23-2.21,3.47-.77,1.66,.15,3.67,1.67,4.8,1.52,1.13,3.49,1.56,5.4,1.84,2.64,.39,5.36,.58,7.96,.02s5.09-1.93,6.44-4.08c.6-.95,.96-2.02,1.66-2.91,1.44-1.84,3.98-2.55,5.98-3.86,2.19-1.43,3.79-4.22,2.5-6.4-1.24-2.1-4.48-2.56-5.77-4.63-.54-.85-.66-1.87-1.01-2.8-.36-.93-1.2-1.4-3.45-2.23Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M90.93,136.59c.38,.44,.83,.92,1.46,.96,.66,.05,1.21-.42,1.64-.87,2.19-2.32,3.64-5.17,4.23-8.1-.54-.31-1.07-.61-1.54-.88-.44-.26-.77-.63-.96-1.06-.13-.32-.18-.65-.14-1,.31-2.9,.58-4.52,1.6-7.46-4.84-1.09-9.41-2.39-12.03-4.58-.32,1.35-.7,3.99-1.51,6.61-.86,2.77-2.2,5.52-4.48,6.7,4.47,2.64,8.46,5.92,11.74,9.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M95.6,125.64c-.03,.35,.01,.68,.14,1-2.86,3.47-9.27-1.07-12.08-6.43,.81-2.62,1.18-5.26,1.51-6.61,2.62,2.19,7.19,3.49,12.03,4.58-1.02,2.94-1.29,4.56-1.6,7.46Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M103.58,167.63c-.63,4.19,3.89,8.7,4,10.94-9.61,0-29.73,.59-39.97-.81-.47-2.59,4.59-8.4,4.59-14.14,0-.76-.03-1.59-.09-2.49-.16-2.56-.54-5.61-.96-8.74-1.14-8.39-2.66-17.36-1.54-19.22,2.2-3.62,7.34-6.09,9.9-7.14,.88-.36,1.45-.56,1.49-.58,3.2,5.46,9.71,10.11,12.17,9.9,.68-.05,2.71-.76,4.05-7.5,.52,.3,1.04,.57,1.56,.84,2.54,1.32,4.93,2.42,5.62,4.12,1.81,4.48,3.59,15.78,3.2,19.79-.4,4.05-2.03,7.15-3.17,11.22-.27,.95-.51,1.96-.71,3.05-.05,.24-.09,.5-.13,.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M107.58,178.57c-9.61,0-29.73,.59-39.97-.81-.47-2.59,4.59-8.4,4.59-14.14,0-.76-.03-1.59-.09-2.49-.16-2.56-.54-5.61-.96-8.74,1.82,1.92,4.47-6.19,5.64-3.81,6.35,12.81,11.35,16.18,20.05,16.18,2.59,0,4.99-.36,7.57-.95-.27,.95-.51,1.96-.71,3.05-.05,.25-.09,.5-.13,.76-.63,4.18,3.89,8.7,4,10.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M98.76,128.69c-.41,3-1.64,7.04-5.19,8.1-4.81,1.44-11.77-7.54-14.07-10.76,.88-.36,1.45-.56,1.49-.58,3.2,5.46,9.71,10.11,12.17,9.9,.68-.05,2.71-.76,4.05-7.5,.52,.29,1.04,.57,1.56,.84Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "100.74 174.06 100.71 177.41 160.52 177.76 160.65 173.97 100.74 174.06"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "186.45 144.21 185.12 142.86 141.55 142.57 119.69 174.18 120.83 175.1 186.45 144.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "142.39 143.74 120.83 175.1 162.01 175.31 186.45 144.21 142.39 143.74"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 152.79,
    cy: 161.36,
    rx: 4.79,
    ry: 2.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M101.62,112.78c.68-3.64,3.18-6.23,5.58-5.79,2.4,.45,3.8,3.76,3.12,7.41-.68,3.64-3.18,6.23-5.58,5.79-2.4-.45-3.8-3.76-3.12-7.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M110.33,102.97c-.45,3.17-1.86,6.67-3.93,10.53-.73-3.16-1.19-7.02-1.83-10.88-.65-3.86-1.48-7.73-2.92-10.88-.32-.7-.68-1.37-1.06-1.98,.85-.08,1.72,0,2.54,.23,1.29,.34,2.49,1.01,3.47,1.89,1.64,1.45,2.73,3.44,3.38,5.53,.54,1.74,.63,3.58,.34,5.56Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M107.91,106.25c-.02,.63-.07,1.26-.12,1.89-.88,10.27-5.19,17.31-11.79,17.31-9.31,0-15.35-10.44-15.35-20.67s6.18-17.4,13.42-16.55c4.17,.48,7.22,1.86,9.39,3.89,1.43,1.35,2.47,2.98,3.17,4.84,.81,2.08,1.2,4.43,1.28,6.97,0,0,0,.02,0,.02,.03,.75,.02,1.51,0,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M107.91,106.25c-.28-.99-.69-1.96-1.25-2.83-5.49,2.87-12.04,3.98-18.24,2.93-1.18,.98-2.33,1.95-3.5,2.92,.02-4.67,.09-7.83,1.91-10.09,1.71-2.12,4.56-2.92,7.26-3.27,3.04-.4,6.13-.38,9.17,.06,1.16,.16,2.37,.41,3.38,1,.81,2.08,1.2,4.43,1.28,6.97,0,0,0,.02,0,.02,.03,.74,.02,1.51,0,2.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M109.25,99.93c-1.28,1.08-2.88,1.98-4.68,2.7-5.12,2.06-11.77,2.75-16.95,2.5-2.55,5.6-3.58,7.6-4.23,12.48-2.49-2.33-4.52-6.61-5.12-9.97-.59-3.35-.54-6.87,.4-10.16,1.47-5.19,5.18-7.97,7.75-9.32,.64-.35,1.22-.59,1.67-.77,3.28-1.27,6.99-1.15,10.35-.12,1.84,.57,3.38,1.54,4.69,2.72,2.63,2.37,4.25,5.59,5.3,8,.33,.74,.6,1.4,.82,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M110.33,102.97c-.21-1.12-.53-2.21-.98-3.26-.25-.59-.56-1.17-.92-1.73-1.17-1.84-2.87-3.35-4.93-4.02-.59-.82-1.2-1.56-1.85-2.22-2.33-2.37-5.07-3.73-7.98-4.21-2.42-.39-4.93-.17-7.25,.62,.64-.35,1.22-.59,1.67-.77,3.28-1.27,6.99-1.15,10.35-.12,1.84,.57,3.38,1.54,4.69,2.72,1.29,.34,2.49,1.01,3.47,1.89,1.64,1.45,2.73,3.44,3.38,5.53,.53,1.74,.63,3.58,.34,5.56Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M90.59,109.26c1.72-.98,3.51-1.43,6.01-.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M102.38,109.19c1.47-1.1,3.66-1.21,4.8,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M100.6,114.8c.15,.78,.07,2.5-.3,3.28"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 94.78,
    cy: 114.21,
    rx: 0.71,
    ry: 1.12
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 104.07,
    cy: 113.69,
    rx: 0.71,
    ry: 1.12
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M99.72,119.61s-.14,.27-.41,.64c-.42,.56-1.13,1.33-2.1,1.63h0c-.41,.13-.85,.18-1.35,.09-1.45-.26-1.83-1.6-1.9-2.63-.02-.2-.02-.39-.01-.56,0-.42,.05-.69,.05-.69,2.31,1.27,5.71,1.52,5.71,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M99.72,119.61s-.14,.27-.41,.64c-1.18-.02-3.6-.62-5.36-1.46,0-.42,.05-.69,.05-.69,2.31,1.27,5.71,1.52,5.71,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M97.22,121.87c-.41,.13-.85,.18-1.35,.09-1.45-.26-1.83-1.6-1.9-2.63,.7,.08,1.38,.36,1.95,.78,.59,.45,1.04,1.07,1.3,1.76Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M83.42,107.49s-.08-4.81,1.92-9.59c2.51-6,7.63-8.57,12.6-8.74,5.99-.21,9.73,3.81,9.73,3.81,0,0-1.95-3.44-5.79-4.43-2.52-.65-6.33-.75-9.39,.49-3.15,1.28-7.07,4.82-8.49,8.57-1.42,3.75-2.11,9.58-2.11,9.58l1.53,.31Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 82.59,
    cy: 112.99,
    rx: 4.67,
    ry: 7.07,
    transform: "translate(-11.24 9.15) rotate(-5.94)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M80.56,108.23c1.65-.25,3.35,1.91,3.79,4.82,.44,2.91-.55,5.47-2.2,5.72-1.65,.25-3.35-1.91-3.79-4.82-.44-2.91,.55-5.47,2.2-5.72Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 97.98,
    cy: 124.05,
    rx: 2.49,
    ry: 1.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M85.5,118.87s3.65,4.69,10,5.18"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M100.71,165.13l-.24,6.17s-22.32,6.69-26,4.57c-1.8-1.03-3.48-6.72-4.73-12.28-1.31-5.84-2.15-11.52-2.15-11.52l13.08-2.56s0,7.98,.45,12.59c.16,1.72,.39,2.97,.69,3.17,1.15,.76,18.9-.15,18.9-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M81.11,162.1c-2.38,.77-6.97,1.96-11.38,1.49-1.31-5.84-2.15-11.52-2.15-11.52l13.08-2.56s0,7.97,.45,12.59Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M100.07,165.19c3.32-.71,8.94-2.42,11.27-3,1.66-.42,5.97,1.81,7.1,3.92,.5,.92,.97,6.12-.76,5.58-.86-.27-.72-2.5-.99-3.41-.22-.74-.92-1.46-1.99-2.08,.71,1.78,.69,3.33,.61,5.25-.02,.42-.04,.87-.25,1.23-.21,.37-.66,.63-1.04,.47-.39-.16-.53-.65-.62-1.08-.3-1.48-.61-2.96-.74-4.64,.03,1.65,0,3.3-.11,4.94-.08,1.26-.7,1.95-1.47,1.73-.34-.1-.48-.41-.63-.83-.23,.81-.81,1.7-1.56,1.36-.46-.2-.74-1.85-.66-3.54-1.44,.89-3.06,1.27-4.92,1.35-1.67,.08-3.39-.24-4.4-1.37,.1-1.78,.69-4.41,1.14-5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M110.5,173.02c.11-1.34,0-2.69-.34-3.98"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M79.19,136.57c-.95-2.67-4.43-8.15-4.43-8.15,0,0-5.31,2.21-7.19,5.95-3.19,6.34-1.57,24.56-1.57,24.56,4.3,1.8,12.92,1.83,16.59,1.31,0,0-1.5-18.33-3.4-23.68Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M79.86,137.69c1.45,6.93,2.22,13.39,2.47,19.72"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 41.28,
    y: 176.66,
    width: 152.16,
    height: 3.82
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnquiryManagement);
export default __webpack_public_path__ + "static/media/enquiryManagement.932651e8b74f56b38b59e20933daf23b.svg";
export { ForwardRef as ReactComponent };